let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i5rM5")).then(() => parcelRequire('l1koE'));